import * as angular from "angular";

export interface AdminDialogSection {
    id: string;
    label: string;
    icon: string;
}

/**
 * AV-17963 dialog chrome: header, left section rail, scrolling body,
 * footer. Purely presentational — the parent form owns submit/cancel.
 */
let AdminDialogShellComponent = {
    selector: "vcAdminDialogShell",
    templateUrl:
        "/angular/components/admin/dialogs/admin-dialog-shell.component.html",
    transclude: true,
    bindings: {
        eyebrow: "@",
        recordId: "<",
        heading: "<",
        status: "<",
        statusClass: "<",
        region: "<",
        created: "<",
        sections: "<",
        section: "=",
        note: "@",
        /** Footer submit copy; defaults to "Save changes" for the edit dialogs. */
        submitLabel: "@",
        saving: "<",
        onCancel: "&",
    },
    controller: class AdminDialogShellController {
        public sections: AdminDialogSection[];
        public section: string;
        public submitLabel: string;

        $onInit(): void {
            if (!this.submitLabel) {
                this.submitLabel = "Save changes";
            }
            if (!this.section && this.sections && this.sections.length) {
                this.section = this.sections[0].id;
            }
        }

        select(id: string): void {
            this.section = id;
        }
    },
};

angular
    .module("admin")
    .component(AdminDialogShellComponent.selector, AdminDialogShellComponent);
